module.exports = __webpack_public_path__ + "static/media/img-emi-main-01.568f1bb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/img-emi-main-01.svg
// module id = 1363
// module chunks = 0